module.exports = __webpack_public_path__ + "img/rankinglist_ranking2.854b4359.png";